import { Card, Stack, Tag, Text } from '@ekhodealer/ekho-common/rev';

import { Table } from '@common/components/Table/Table';

// Mock data
const mockData = [
	{
		id: '1',
		service: 'Sales processing engine',
		pricePerMonth: '$0',
		status: 'Active',
		description: `
	Checkout, payments, financing intake, titling/registration intake, ID/fraud checks, delivery/pickup, orchestration.`,
	},
];

const columns = [
	{
		id: 'service',
		title: 'Service',
		renderCell: (item: {
			id: string;
			status: string;
			description: string;
			pricePerMonth: string;
			service: string;
		}) => <div style={{ fontWeight: 500, color: '#333' }}>{item.service}</div>,
	},
	{
		id: 'pricePerMonth',
		title: 'Price/month',
		renderCell: (item: {
			id: string;
			status: string;
			description: string;
			pricePerMonth: string;
			service: string;
		}) => <div style={{ fontSize: '13px' }}>{item.pricePerMonth}</div>,
	},
	{
		id: 'status',
		title: 'Status',
		renderCell: (item: {
			id: string;
			status: string;
			description: string;
			pricePerMonth: string;
			service: string;
		}) => {
			return <Tag accent={1}>{item.status}</Tag>;
		},
	},
	{
		id: 'description',
		title: 'Description',
		renderCell: (item: {
			id: string;
			status: string;
			description: string;
			pricePerMonth: string;
			service: string;
		}) => <div style={{ fontSize: '13px' }}>{item.description}</div>,
	},
];

function ServiceFee() {
	return (
		<Card className='w-card no-shadow'>
			<Stack itemsSpacing='16'>
				<Stack itemsSpacing='4'>
					<Text size='body' weight='semibold'>
						Software fees
					</Text>
					<Text size='bodySmall' color='secondary'>
						Monthly software modules. Charged regardless of sales volume.
					</Text>
				</Stack>
				<Table
					columns={columns}
					items={mockData}
					getItemId={(item: {
						id: string;
						status: string;
						description: string;
						pricePerMonth: string;
						service: string;
					}) => item.id}
				/>
			</Stack>
		</Card>
	);
}

export default ServiceFee;
